// extracted by mini-css-extract-plugin
export default {"input":"input--P9n8g","text":"text--+Td9q"};